class ProductHowTo extends HTMLElement {
  connectedCallback() {
    this.filterButtons = this.querySelectorAll('[data-filter]');
    this.items = this.querySelectorAll('[data-category]');

    this.filterButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.setFilter(btn));
    });
  }

  setFilter(activeBtn) {
    const category = activeBtn.dataset.filter;

    this.filterButtons.forEach((btn) => {
      const isActive = btn === activeBtn;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.items.forEach((item) => {
      item.hidden = category !== 'all' && item.dataset.category !== category;
    });
  }
}

customElements.define('product-how-to', ProductHowTo);
